import { validateId } from '~/repositories/utils';
import { BaseRestRepository } from './baseRestRepository';
import type { LeaseTransactionReceiptDto } from '~/swagger/portal/Api';

const BASE_URL = '/api/leases';

export class LeaseTransactionReceiptRepository extends BaseRestRepository {
  public async getReceipt(leaseId: string, transactionId: string): Promise<LeaseTransactionReceiptDto> {
    validateId(leaseId);
    validateId(transactionId);
    const url = `${BASE_URL}/${leaseId}/transactions/${transactionId}/receipt`;
    const response = await this.fetchWithAuth(url, { method: 'GET' });
    return this.getJsonResponse(response);
  }

  public async send(leaseId: string, transactionId: string): Promise<LeaseTransactionReceiptDto> {
    validateId(leaseId);
    validateId(transactionId);
    const url = `${BASE_URL}/${leaseId}/transactions/${transactionId}/receipt/send`;
    const response = await this.fetchWithAuth(url, { method: 'POST', body: JSON.stringify({}) });
    return this.getJsonResponse(response);
  }
}

export const leaseTransactionReceiptRepository = new LeaseTransactionReceiptRepository();
